import { Dialog, DialogContent, DialogProps } from '@mui/material';

import React, { FC, PropsWithChildren, type JSX } from 'react';

import './Modal.sass';

import UntitledIcon from '@payaca/untitled-icons';

export type Props = {
  className?: string;
  isOpen: boolean;
  showCloseControl?: boolean;
  actions?: React.ReactNode;
  size?: false | 'sm' | 'xs' | 'md' | 'lg' | 'xl';
  title?: React.ReactNode;
  onClose?: () => void;
  disableBackdropClick?: boolean;
};
const Modal: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  isOpen,
  showCloseControl = true,
  actions,
  size,
  title,
  onClose,
  disableBackdropClick = false,
}: PropsWithChildren<Props>): JSX.Element => {
  const onCloseInternal: DialogProps['onClose'] = (event, reason) => {
    if (!disableBackdropClick || reason !== 'backdropClick') {
      onClose?.();
    }
  };
  return (
    <Dialog
      disableEnforceFocus
      open={isOpen}
      onClose={onCloseInternal}
      fullWidth={true}
      maxWidth={size || 'sm'}
      classes={{
        root: `modal !z-modal1 ${className ? className : ''}`,
      }}
    >
      {showCloseControl && (
        <div className="close-control" onClick={onClose}>
          <UntitledIcon name="x.3" />
        </div>
      )}
      <DialogContent>
        {title && (
          <div className="title-container">
            {typeof title === 'string' ? (
              <h1 className="title">{title}</h1>
            ) : (
              title
            )}
          </div>
        )}
        {children && <div className="body-content">{children}</div>}
        {actions && <div className="actions-container">{actions}</div>}
      </DialogContent>
    </Dialog>
  );
};
export default Modal;
